import * as React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import LanguageStrings from '../../../../i18n/locales'
import EnhancedTable from './ActiveAlarmsList'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel (props: TabPanelProps): any {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ paddingTop: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

function a11yProps (index: number): any {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}

export default function BasicTabs (props: { compHeight: number, issuesTabHeight: number }): any {
  const [value, setValue] = React.useState(0)
  const AMIMeterCollectionStrings = LanguageStrings().AMIDataCollectionStrings.LandingPage

  const handleChange = (event: React.SyntheticEvent, newValue: number): any => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderColor: 'divider', backgroundColor: '#313030', paddingLeft: '20px' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label={AMIMeterCollectionStrings.Active_Issues} {...a11yProps(0)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <EnhancedTable/>
      </TabPanel>
    </Box>
  )
}
